import axios from "axios";
import store from "../store";

export default () => {
  return axios.create({
    baseURL:
      process.env.NODE_ENV === "production"
        ? "https://rgift.co.il/api"
        : "http://localhost:3500/api",
    headers: {
      Authorization: `Bearer ${store.state.AuthModule.token}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
  });
};
